<template>
    <div class="text" @click="clickHandler">{{ data }}</div>
</template>

<script>
export default {
    name: "PlatText",
    props: ["data"],
    methods: {
        clickHandler(event) {
            this.$emit("colClick", {
                event: event,
                type: "Text"
            });
        }
    }
};
</script>

<style lang="less" scoped>
.text {
    word-break: break-all;
    word-wrap: break-word;
}
</style>
